<div *ngIf="referralFormQuestionGroup && referralFormQuestionGroup.questionGroup">
    <h3 class="form-page__title">
        <span>{{questionGroupIndex}}</span>
        {{referralFormQuestionGroup.questionGroup.description}}
    </h3>

    <ol class="question__list" *ngFor="let qgq of getQuestionGroupQuestions(); let i = index">
      <li class="question__item">
        <app-question-group-question
            [isReadOnly]="isReadOnly"
            [questionGroupQuestion]="qgq"
            [questionGroupIndex]="questionGroupIndex"
            [questionIndex]="(i + 1).toString()"
            (questionAnsweredEvent)="questionAnswered(qgq)">
        </app-question-group-question>
      </li>
    </ol>
</div>
